import React from "react";

function BirdsForm({ additionalAttributes, setAdditionalAttributes }) {
  const handleChange = (e) => {
    setAdditionalAttributes({
      ...additionalAttributes,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="birdsForm">
      {/* Quş növü */}
      <div>
        <h3>Quş növü <span>*</span></h3>
        <select name="birdType" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Kanareyka">Kanareyka</option>
          <option value="Bülbül">Bülbül</option>
          <option value="Tutuquşu">Tutuquşu</option>
          <option value="Göyərçin">Göyərçin</option>
          <option value="Qartal">Qartal</option>
          <option value="Başqa">Başqa</option>
        </select>
      </div>

      {/* Yaş */}
      <div>
        <h3>Yaş <span>*</span></h3>
        <input type="number" name="age" min="0" max="50" required placeholder="Yaşı daxil edin" onChange={handleChange} />
      </div>

      {/* Cins */}
      <div>
        <h3>Cins <span>*</span></h3>
        <select name="gender" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Erkək">Erkək</option>
          <option value="Dişi">Dişi</option>
          <option value="Naməlum">Naməlum</option>
        </select>
      </div>

      {/* Rəng */}
      <div>
        <h3>Rəng <span>*</span></h3>
        <input type="text" name="color" required placeholder="Rəngi daxil edin" onChange={handleChange} />
      </div>

      {/* Sağlamlıq vəziyyəti */}
      <div>
        <h3>Sağlamlıq vəziyyəti <span>*</span></h3>
        <select name="healthStatus" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Sağlam">Sağlam</option>
          <option value="Müalicə olunmuş">Müalicə olunmuş</option>
          <option value="Xəstə">Xəstə</option>
        </select>
      </div>

      {/* İstifadə vəziyyəti */}
      <div>
        <h3>İstifadə vəziyyəti <span>*</span></h3>
        <select name="condition" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="Yeni (Bala)">Yeni (Bala)</option>
          <option value="Böyümüş quş">Böyümüş quş</option>
        </select>
      </div>

      {/* Qəfəs və aksesuarlar */}
      <div>
        <h3>Qəfəs və aksesuarlar daxildirmi? <span>*</span></h3>
        <select name="includesCage" required onChange={handleChange}>
          <option value="" disabled selected>Seçin</option>
          <option value="true">Bəli</option>
          <option value="false">Xeyr</option>
        </select>
      </div>
    </div>
  );
}

export default BirdsForm;
